var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_listCacheHas.js
// module id = ./node_modules/lodash/_listCacheHas.js
// module chunks = 0 1